export default (function (siteVariables) {
  return {
    controlColor: siteVariables.bodyBackground,
    controlBackgroundColor: 'rgba(0,0,0,.25)',
    width: undefined,
    height: undefined,
    focusBorderColor: siteVariables.colors.brand[500]
  };
});